__turbopack_context__.v({
  "container": "C-1BoW_container",
  "control": "C-1BoW_control",
  "isBouncing": "C-1BoW_isBouncing",
  "lock": "C-1BoW_lock",
});
